// TODO: Support different environments (local, dev, production)
export const BASE_API_URL = "https://pub.api.muun.io"
export const FEE_ESTIMATOR_LANDING_CSV_URL = `${BASE_API_URL}/fee-estimator/public/landing/`
